module.exports = __webpack_public_path__ + "static/img/keno-banner_new.3f8b06e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/keno-banner_new.jpg
// module id = Sc5I
// module chunks = 1